import { useEffect } from 'react';
import { usePageStore } from '@legacy/stores/PageStore/pageStore.zustand';

export const useIframeEvent = () => {
  const setCurrentPage = usePageStore((state) => state.setCurrentPage);

  useEffect(() => {
    const handleIframeEvent = (event: MessageEvent) => {
      const {
        data: { pageIdentifier, eventId, pageId, pageTitle },
      } = event;
      if (eventId === 'pageIdentifier' && setCurrentPage) {
        setCurrentPage({
          pageIdentifier,
          pageId,
          pageTitle,
        });
      }
    };

    window?.addEventListener('message', handleIframeEvent as EventListener);

    return () => {
      window?.removeEventListener(
        'message',
        handleIframeEvent as EventListener,
      );
    };
  }, [setCurrentPage]);
};
